import React from "react";
import { Paper, Box, Typography, TextField, Button, FormControlLabel, Switch } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import ListAltIcon from "@mui/icons-material/ListAlt";

// "2026-10-30" -> "30/10/2026"
const formatearFecha = (fecha) => (fecha ? fecha.split("-").reverse().join("/") : "");

export const HeaderFiltros = ({
  desde,
  hasta,
  setDesde,
  setHasta,
  onActualizar,
  loading,
  incluirDescartados,
  setIncluirDescartados,
  cantidadDescartados
}) => (
  <Paper
    elevation={0}
    sx={{
      p: 2,
      mb: 2,
      border: "1px solid #e0e0e0",
      borderRadius: 2,
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: 2,
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexGrow: 1, minWidth: 220 }}>
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: 2,
          bgcolor: "#e8f0fe",
          color: "#1a73e8",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ListAltIcon />
      </Box>
      <Box>
        <Typography variant="h6" fontWeight={600} sx={{ color: "#202124", lineHeight: 1.2 }}>
          Todos los Pedidos
        </Typography>
        <Typography variant="body2" sx={{ color: "#5f6368" }}>
          Del {formatearFecha(desde)} al {formatearFecha(hasta)}
        </Typography>
      </Box>
    </Box>

    <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1.5 }}>
      <TextField
        size="small"
        label="Desde"
        type="date"
        value={desde}
        onChange={(e) => setDesde(e.target.value)}
        InputLabelProps={{ shrink: true }}
        sx={{ bgcolor: "#fff", width: 160 }}
      />
      <TextField
        size="small"
        label="Hasta"
        type="date"
        value={hasta}
        onChange={(e) => setHasta(e.target.value)}
        InputLabelProps={{ shrink: true }}
        sx={{ bgcolor: "#fff", width: 160 }}
      />
      <FormControlLabel
        control={
          <Switch
            size="small"
            checked={incluirDescartados}
            onChange={(e) => setIncluirDescartados(e.target.checked)}
          />
        }
        label={
          <Typography variant="body2" sx={{ color: "#5f6368" }}>
            Incluir descartados ({cantidadDescartados})
          </Typography>
        }
        sx={{ mr: 0 }}
      />
      <Button
        variant="contained"
        onClick={onActualizar}
        disabled={loading}
        startIcon={<RefreshIcon />}
        disableElevation
        sx={{ textTransform: "none", fontWeight: 500, borderRadius: 2 }}
      >
        {loading ? "Cargando..." : "Actualizar"}
      </Button>
    </Box>
  </Paper>
);
